// g0-approved-blueprint-bytes-lookup.ts — V2-1 (spec §4.1 "Nguồn thẩm quyền").
//
// Bytes BLUEPRINT có sha256 == một hash G0, tìm theo thứ tự rẻ → đắt (review
// L4 — `status` gọi mỗi lần):
//  1. snapshot control root `g0-blueprint-<hash>.md` (mission V2);
//  2. `HEAD:<source_path>` (một `git show`);
//  3. lịch sử HEAD: ≤100 commit chạm path (mission v1 không snapshot; base_sha
//     không được lưu ở control root nên không đọc thẳng được bytes tại base_sha).
// Mọi nguồn đều hash lại ⇒ khớp hash nghĩa là ĐÚNG bytes đã duyệt, bất kể
// lấy ở đâu. Không bao giờ đọc file live trong worktree.
import { execFile } from "node:child_process";
import { promisify } from "node:util";
import { sha256HexOfBytes } from "./blueprint-gate-hash.js";
import { readG0BlueprintSnapshot } from "./g0-blueprint-snapshot-store.js";
import { loadCommittedBlueprintBytes } from "./mission-blueprint-committed-bytes-check.js";

const execFileAsync = promisify(execFile);
/** Số commit tối đa lùi lại tìm bytes đã duyệt (nguồn 3). */
const MAX_HISTORY_COMMITS = 100;

async function bytesFromGitHistory(
  repoDir: string,
  path: string,
  sha256: string,
): Promise<Buffer | undefined> {
  try {
    const { stdout } = await execFileAsync(
      "git",
      ["log", `-n${MAX_HISTORY_COMMITS}`, "--format=%H", "HEAD", "--", path],
      { cwd: repoDir },
    );
    for (const commit of stdout.split("\n").filter((c) => c.length > 0)) {
      const bytes = await loadCommittedBlueprintBytes(repoDir, path, commit);
      if (bytes !== undefined && sha256HexOfBytes(bytes) === sha256) return bytes;
    }
  } catch {
    // git lỗi ⇒ không có nguồn 3 (caller về `ask`).
  }
  return undefined;
}

export async function loadBlueprintBytesWithHash(
  controlRoot: string,
  repoDir: string,
  sourcePath: string,
  sha256: string,
): Promise<Buffer | undefined> {
  const hash = sha256.toLowerCase();
  const snapshot = await readG0BlueprintSnapshot(controlRoot, hash);
  if (snapshot !== undefined) return snapshot;
  const path = sourcePath.replace(/\\/g, "/");
  const head = await loadCommittedBlueprintBytes(repoDir, path, "HEAD");
  if (head !== undefined && sha256HexOfBytes(head) === hash) return head;
  return bytesFromGitHistory(repoDir, path, hash);
}
